import BASEURLGESTTOR from '../api/gesttor'
import { cadastrarAsaasPayload, atualiAsaasPayload} from '../../interfaces/asaas'

export function buscarIntegracao () {
    return BASEURLGESTTOR.get('/asaas')
}

export function cadastrarIntegracao (payload: cadastrarAsaasPayload) {
    return BASEURLGESTTOR.post ('/asaas', payload)
}

export function atualizarIntegracao (payload: atualiAsaasPayload) {
    return BASEURLGESTTOR.patch('/asaas', payload)
}

export function cadastrarWebHook () {
    return BASEURLGESTTOR.put('/asaas')
}